import styled from '@emotion/styled';
import { useField } from 'formik';
import * as React from 'react';
import PhoneInput, { formatPhoneNumber, isPossiblePhoneNumber, isValidPhoneNumber, parsePhoneNumber, } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { StyledDescription, StyledTitle } from '../text-input';
import { StyledPhoneInput } from './PhoneNumberInput.styled';
import { theme } from '../../../theme';
import { getErrorIconStyles } from '../text-input/styles';
const Container = styled.div `
	padding: 0.25rem 0;
	width: 100%;

	margin-bottom: ${({ touched, error }) => touched && error ? '2rem' : '1rem'};
`;
const StyledLabel = styled.label `
	display: flex;
	flex-direction: column;
	margin-bottom: 0;
	width: 100%;
	padding: 0;
	position: relative;
`;
const StyledErrorMsg = styled.span `
	${theme.typography.IR90};
	color: ${theme.colors.NE100};
	padding: 0.5rem 0;
	position: absolute;
	margin-top: 2px;
`;
const StyledErrorIcon = styled.span `
	position: relative;
	display: inherit;
	width: auto;

	${({ error, touched }) => ({
    ':after': Object.assign({}, getErrorIconStyles(error, touched)),
})};
`;
/** Helper function to parse an international number into it's constituents */
export const HUIparsePhoneNumber = parsePhoneNumber;
/** Helper function to format an international number into a local user-friendly format */
export const HUIformatPhoneNumber = formatPhoneNumber;
/** Helper function to validate on length */
export const HUIisPossiblePhoneNumber = isPossiblePhoneNumber;
/** Helper function to validate if a number is an international number */
export const HUIisValidPhoneNumber = isValidPhoneNumber;
export const PhoneNumberInput = (props) => {
    var _a;
    // Formik connector
    const [, meta, helpers] = useField(props);
    const { touched, error, value: formValue } = meta;
    const { setTouched, setValue } = helpers;
    const onChange = (value) => {
        void setValue(value);
        if (props.onChange) {
            props.onChange(value);
        }
    };
    const onCountryChange = (country) => {
        if (props.onCountryChange) {
            props.onCountryChange(country);
        }
    };
    const inputProps = {
        defaultCountry: (_a = props.defaultCountry) !== null && _a !== void 0 ? _a : 'GB',
        onChange,
        onCountryChange,
        value: formValue,
    };
    return (React.createElement(Container, { touched: touched, error: error, style: props.style },
        React.createElement(StyledLabel, null,
            React.createElement(StyledTitle, null, props.label),
            props.description && (React.createElement(StyledDescription, null, props.description))),
        React.createElement(StyledErrorIcon, { touched: touched, error: error },
            React.createElement(StyledPhoneInput, Object.assign({ "data-testid": "input", "aria-label": props['aria-label'] || props.label }, meta),
                React.createElement(PhoneInput, Object.assign({}, inputProps, { onBlur: () => void setTouched(true), "data-testid": "phone-input" })))),
        touched && error && (React.createElement(StyledErrorMsg, { "data-testid": "input-error" }, error))));
};
//# sourceMappingURL=PhoneNumberInput.js.map